import React from 'react';
import { Helmet } from 'react-helmet';
import { PRISMIC_API_ENDPOINT_V2 } from 'utils/Prismic/PrismicConstants';
import { PLATFORMS } from '~/constants';

import { WlWindow } from '../../../typings/globals/cordova';
import IncludeOnPlatforms from '../../hoc/IncludeOnPlatforms';

declare const window: WlWindow;

window.prismic = {
  endpoint: PRISMIC_API_ENDPOINT_V2,
};

function PrismicHelmet() {
  return (
    <Helmet>
      <script
        type="text/javascript"
        src="https://static.cdn.prismic.io/prismic.min.js?new=true"
      />
    </Helmet>
  );
}

export default IncludeOnPlatforms([PLATFORMS.PIZZA, PLATFORMS.WEB])(
  PrismicHelmet,
);
